export default __webpack_public_path__ + "src/images/number_portfolio-285c30.xml";